var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5,
    height: 21.321,
    x: 0.5,
    y: 0.5,
    stroke: "#80959D",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.5 4.978H12v12.365H.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.445,
    cy: 2.886,
    fill: "#80959D",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.634,
    height: 1.12,
    x: 5.433,
    y: 19.243,
    fill: "#80959D",
    rx: 0.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0d23f1892cdd9493cdd7c7a6454bfe35.svg";
export { ForwardRef as ReactComponent };